import styles from './uploadDeliveryNoteModal.module.css'
import { useEffect, useState } from "react"
import { FieldType, FileField, FileType, Form, FormField, Modal, ModalId, useUIActions, useUIState, Validatable } from "../../../../../features/ui"
import { useActions } from "./actions"
import { toList } from "../../../../../utils/listUtils"
import { fileHelpers } from "../../../../../features/files"
import { Delivery, DeliveryMethod, DeliveryOrder } from '../../../state/types'

type Props = {
    delivery?: Delivery
    deliveryOrder?: DeliveryOrder
    onUpload: () => Promise<void>
}

export const UploadDeliveryNoteModal = (props: Props) => {
    const { delivery, deliveryOrder, onUpload } = props

    const [deliveryNoteFile, setDeliveryNoteFile] = useState<File>()
    const [deliveryNoteValidation, setDeliveryNoteValidation] = useState<string>()
    const [key, setKey] = useState(0)
    
    const { openedModal } = useUIState()
    
    const { deliveryNoteFileName2 } = fileHelpers

    const { submitDeliveryNote } = useActions()
    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    const deliveryNoteLabel = delivery?.method === DeliveryMethod.RECEPTION ? 'Remito del Proveedor' : 'Remito Firmado'

    const onChangeDeliveryNoteFile = (value?: File) => {
        setDeliveryNoteValidation(undefined)
        setDeliveryNoteFile(value)
    }

    const fields: FormField[] = [
        {
            name: 'deliveryNoteUrl',
            type: FieldType.FILE,
            label: deliveryNoteLabel,
            hint: 'Formato: PDF, JPG, PNG',
            render: () => (
              <Validatable
                validations={toList(deliveryNoteValidation)}
                left
                className={styles.deliveryNoteValidation}
            >
                <FileField
                    id="deliveryNoteUrl"
                    fileName={delivery ? deliveryNoteFileName2(delivery, deliveryOrder) : undefined}
                    fileTypes={[FileType.PDF, FileType.JPEG, FileType.PNG]}
                    onChange={onChangeDeliveryNoteFile}
                />
              </Validatable>
            )
        }
    ]

    const validate = (): boolean => {
        if (!deliveryNoteFile) {
            setDeliveryNoteValidation(`Debe subir el ${deliveryNoteLabel.toLowerCase()}`)
            return false
        }
    
        return true
    }

    const onSubmit = () => {
        if (validate()) {
            submitDeliveryNote(delivery!.id, deliveryNoteFile!, onUpload)
            closeModal(ModalId.UPLOAD_DELIVERY_NOTE)
            setDeliveryNoteValidation(undefined)
        }
    }

    const onCancel = () => {
        closeModal(ModalId.UPLOAD_DELIVERY_NOTE)
        setDeliveryNoteValidation(undefined)
    }

    return (
        <Modal
            modalId={ModalId.UPLOAD_DELIVERY_NOTE}
            title={`Subir ${deliveryNoteLabel}`}
            widthSize="m"
            actions={[]}
        >
            <Form
                key={key}
                formId="upload-delivery-note-form"
                fields={fields}
                createMode={false}
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
        </Modal>
    )
}
